// 由 EB view/admin/src/router/modules/userFeedback.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const userFeedbackRouter: RouteRecordRaw =
  {
    path: `${roterPre}/feedback`,
    name: 'Feedback',
    meta: {
      icon: 'dashboard',
      title: '用户反馈管理'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'classify',
        name: 'FeedbackClassify',
        meta: {
          title: '反馈分类',
          noCache: true
        },
        component: () => import('@/views/userFeedback/classify/index.vue')
      },
      {
        path: 'list',
        name: 'FeedbackList',
        meta: {
          title: '反馈列表',
          noCache: true
        },
        component: () => import('@/views/userFeedback/list/index.vue')
      }
    ]
  }

export default userFeedbackRouter;
